export default __webpack_public_path__ + "static/media/g2019-1.1b096f94.jpeg";